function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#da0000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9f0000"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_57",
  "data-name": "Group 57",
  transform: "translate(-3227.407 -3247.416)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_54",
  "data-name": "Path 54",
  d: "M3253.107,3247.708a8.526,8.526,0,0,1,5.756.478h0a8.54,8.54,0,0,0,7.088,0h0a8.546,8.546,0,0,1,10.5,2.814h0a8.543,8.543,0,0,0,6.139,3.544h0a8.548,8.548,0,0,1,7.688,7.687h0a8.538,8.538,0,0,0,3.544,6.139h0a8.547,8.547,0,0,1,2.814,10.5h0a8.543,8.543,0,0,0,0,7.089h0a8.546,8.546,0,0,1-2.814,10.5h0a8.538,8.538,0,0,0-3.544,6.139h0a8.546,8.546,0,0,1-7.688,7.687h0a8.552,8.552,0,0,0-6.139,3.544h0a8.542,8.542,0,0,1-10.5,2.814h0a8.54,8.54,0,0,0-7.088,0h0a8.542,8.542,0,0,1-10.5-2.814h0a8.552,8.552,0,0,0-6.139-3.544h0a8.543,8.543,0,0,1-7.687-7.687h0a8.544,8.544,0,0,0-3.545-6.139h0a8.544,8.544,0,0,1-2.813-10.5h0a8.552,8.552,0,0,0,0-7.089h0a8.545,8.545,0,0,1,2.813-10.5h0a8.544,8.544,0,0,0,3.545-6.139h0a8.546,8.546,0,0,1,7.687-7.687h0a8.543,8.543,0,0,0,6.139-3.544h0A8.521,8.521,0,0,1,3253.107,3247.708Z",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_34",
  "data-name": "Ellipse 34",
  cx: 29.15,
  cy: 29.15,
  r: 29.15,
  transform: "translate(3233.258 3253.266)",
  fill: "none",
  stroke: "#fbb03b",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_56",
  "data-name": "Group 56"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_55",
  "data-name": "Path 55",
  d: "M3269.367,3283.683c-.043,2-3.006,3.612-6.654,3.612s-6.612-1.613-6.655-3.612a10.966,10.966,0,0,0-9.955,10.918c0,6.056,4.909,6.04,10.964,6.04h11.292c6.054,0,10.964.016,10.964-6.04A10.966,10.966,0,0,0,3269.367,3283.683Z",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_56",
  "data-name": "Path 56",
  d: "M3262.713,3283.339c-3.7,0-6.765-4.015-7.256-9.227h-1.007c.559,5.936,4.044,10.51,8.263,10.51s7.7-4.574,8.263-10.51h-1.008C3269.476,3279.324,3266.417,3283.339,3262.713,3283.339Z",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_57",
  "data-name": "Path 57",
  d: "M3254.057,3272.877h17.312a1.221,1.221,0,1,0,0-2.442h-.333a8.324,8.324,0,0,0-4.565-7.426l-.69,3.911a.637.637,0,0,1-.628.527.691.691,0,0,1-.111-.009.638.638,0,0,1-.517-.739l.787-4.468a1.67,1.67,0,0,0-1.419-.788h-2.362a1.671,1.671,0,0,0-1.418.788l.788,4.468a.638.638,0,0,1-.517.739.6.6,0,0,1-.112.009.637.637,0,0,1-.628-.527l-.689-3.91a8.317,8.317,0,0,0-4.566,7.425h-.332a1.221,1.221,0,0,0,0,2.442Z",
  fill: "#fbb03b"
})));

var SvgEngineerOn = function SvgEngineerOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEngineerOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/engineer-on.d1ea3512.svg";
export { ForwardRef as ReactComponent };